import React from "react";
import PropTypes from "prop-types";

import { Link, useLocation } from "react-router-dom";

// react-router v6 removed the legacy context.router.isActive() API this used
// to rely on; useLocation() gives the same exact-match "is this nav item the
// current page" check without needing a class component or context.
export default function NavLink({ to, children, ...rest }) {
	const location = useLocation();
	const isActive = `${location.pathname}${location.search}` === to;

	return (
		<li className={isActive ? "active" : ""} role="presentation">
			<Link to={to} {...rest}>
				{children}
			</Link>
		</li>
	);
}

NavLink.propTypes = {
	to: PropTypes.string,
	children: PropTypes.node,
};
